module.exports = "pegasus/assets/styleGroup2-linkedin.png";